import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useDDJJEnabledGoodsStatement = () => {
    const [enabledStatements, setEnabledStatements] = useState({});

    useEffect(() => {
        setEnabledStatements({
            II1: configUtils.getBoolean("comex.ddjj.goods.II1.enabled"),
            II2: configUtils.getBoolean("comex.ddjj.goods.II2.enabled"),
            II3: configUtils.getBoolean("comex.ddjj.goods.II3.enabled"),
            II4: configUtils.getBoolean("comex.ddjj.goods.II4.enabled"),
            II5: configUtils.getBoolean("comex.ddjj.goods.II5.enabled"),
            II6: configUtils.getBoolean("comex.ddjj.goods.II6.enabled"),
        });
    }, []);

    return { enabledStatements };
};

export default useDDJJEnabledGoodsStatement;
